// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deposit-logo-component {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}
.deposit-logo-component .deposit-logo-image-container {
  height: 60px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.deposit-logo-component .deposit-logo-image-container .deposit-logo-image {
  height: 50px;
  width: 96px;
  background-size: contain;
  background-position: center left;
  background-repeat: no-repeat;
}
.deposit-logo-component .deposit-logo-text {
  margin: 8px 10px 10px 10px;
  font-size: 20px;
  font-weight: bold;
  transform: translateY(10px);
}`, "",{"version":3,"sources":["webpack://./src/app/components/cashier/deposit-logo/deposit-logo.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,cAAA;AACJ;AACI;EACI,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACR;AACQ;EACI,YAAA;EACA,WAAA;EACA,wBAAA;EACA,gCAAA;EACA,4BAAA;AACZ;AAGI;EACI,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AADR","sourcesContent":[".deposit-logo-component{\r\n    display:  flex;\r\n    justify-content: center;\r\n    margin: 10px 0;\r\n\r\n    .deposit-logo-image-container{\r\n        height: 60px;\r\n        width: 100px;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        .deposit-logo-image{\r\n            height: 50px;\r\n            width: 96px;\r\n            background-size: contain;\r\n            background-position: center left;\r\n            background-repeat: no-repeat;\r\n        }\r\n    }\r\n\r\n    .deposit-logo-text{\r\n        margin: 8px 10px 10px 10px;\r\n        font-size: 20px;\r\n        font-weight: bold;\r\n        transform: translateY(10px);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
